import { sha256 } from "js-sha256";

export async function getUploadUrl(file, folder) {
    var now_string = Date.now().toString();
    const extension = file.name?.split('.').pop();
    const filename = encodeURIComponent(sha256(file.name + now_string).toString() + "." + extension);
    return fetch(`/api/0.2/upload-url?file=${filename}&path=${folder}`);
}

export async function uploadFileToPresignedUrl(file, url, fields) {
    return new Promise(async (resolve, reject) => {
        const formData = new FormData();
        // formData.append('x-amz-acl', 'public-read'); // give file public read access
        Object.entries({ ...fields, file }).forEach(([key, value]) => {
          formData.append(key, value);
        });
    
        const upload = await fetch(url, {
          method: 'POST',
          body: formData,
        });
        resolve(upload);
    });
}

// Legacy function that we used in the early prototype
export async function uploadDirectlyFromFrontend(data, current_user) {
    return new Promise(async (resolve, reject) => {
        const url = "https://car-sharing-e46aad.appdrag.site/api/add-car";
        const formData = new FormData();
    
        // Attach an initial photo
        formData.append('photo', data.carphoto[0]);
        // extract from user object:
        formData.append('owner_uid', current_user.uid);
        formData.append('owner_email', current_user.email);
        // Insert text-field data
        formData.append('make', data.car_make);
        formData.append('model', data.car_model);
        formData.append('manufacturing_year', data.car_manufacturing_year);
        formData.append('odometer', data.odometer_reading);
        // Geo-search to be implemented
        formData.append('lat', 54.6871555); // to be replaced by Google Maps API provided lat/lng
        formData.append('lng', 25.2796514);
        // Car UID:
        var now_string = Date.now().toString();
        var formToString = new URLSearchParams(formData).toString();
        const car_uid = sha256(formToString + now_string).toString();
        formData.append('uid', car_uid);
    
        const upload = await fetch(url, {
          method: 'POST',
          body: formData,
        });
    
        console.log("Upload response: ");
        console.log(upload);
    
        console.log("Upload JSON response: ");
        console.log(upload.json());

        resolve(upload);
    });
}

// import { createItemWithFile } from "util/db.js";
    // createItemWithFile(formData)
    //   .then(() => {
    //     // Clear form
    //     reset();
    //     // Show success alert message
    //     setFormAlert({
    //       type: "success",
    //       message: `Jūsų automobilio duomenys išsiųsti peržiūrai! Apie statusą informuosime jus el. paštu: ${auth.user.email}`,
    //     });
    //   })
    //   .catch((error) => {
    //     // Show error alert message
    //     setFormAlert({
    //       type: "error",
    //       message: error.message,
    //     });
    //   })
    //   .finally(() => {
    //     // Hide pending indicator
    //     setPending(false);
    //   });
    // // reset();